export * as segmentationRules from './index';
